import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faBalanceScale } from '@fortawesome/pro-regular-svg-icons/faBalanceScale'
import { faBrain } from '@fortawesome/pro-regular-svg-icons/faBrain'
import { faClouds } from '@fortawesome/pro-regular-svg-icons/faClouds'
import { faDna } from '@fortawesome/pro-regular-svg-icons/faDna'
import { faHeadSideBrain } from '@fortawesome/pro-regular-svg-icons/faHeadSideBrain'
import { faHeartPulse } from '@fortawesome/pro-regular-svg-icons/faHeartPulse'
import { faLungs } from '@fortawesome/pro-regular-svg-icons/faLungs'

export type ConditionOption = {
  bgColor: string
  color: string
  condition: string
  icon: IconDefinition
}

// Suggested conditions with relevant icons for display
export const SUGGESTED_CONDITIONS: ConditionOption[] = [
  {
    bgColor: 'bg-primary100 ',
    color: 'text-primary600',
    condition: 'Anxiety',
    icon: faHeadSideBrain,
  },
  {
    bgColor: 'bg-turquoise100',
    color: 'text-turquoise800',
    condition: 'Depression',
    icon: faClouds,
  },
  {
    bgColor: 'bg-blue100',
    color: 'text-blue600',
    condition: "Alzheimer's Disease",
    icon: faBrain,
  },
  {
    bgColor: 'bg-green100',
    color: 'text-green700',
    condition: 'Weight Loss',
    icon: faBalanceScale,
  },
  {
    bgColor: 'bg-hope200',
    color: 'text-hope800',
    condition: 'Heart Disease',
    icon: faHeartPulse,
  },
  {
    bgColor: 'bg-warning100',
    color: 'text-warning600',
    condition: 'Cancer',
    icon: faDna,
  },
  {
    bgColor: 'bg-success100',
    color: 'text-success600',
    condition: 'Asthma',
    icon: faLungs,
  },
]
